module.exports = __webpack_public_path__ + "static/media/VOLTAS_F1.d494d465.txt";